import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './components/App';
import { AuthProvider } from './context/AuthContext';
import { DataProvider } from './context/DataContext';
import './index.css';
// Initialize Lottie splash animation immediately for native mobile app launch
let lottieAnimInstance: any = null;
const lottieContainer = document.getElementById('lottie-splash');
const isNativePlatform = 
    document.documentElement.classList.contains('is-native-app') ||
    window.location.protocol === 'file:' || 
    window.location.origin.indexOf('capacitor://') !== -1 ||
    window.location.origin.indexOf('ionic://') !== -1 ||
    Boolean(
        (window as any).Capacitor && 
        typeof (window as any).Capacitor.isNativePlatform === 'function' && 
        (window as any).Capacitor.isNativePlatform()
    );

if (lottieContainer && isNativePlatform) {
    Promise.all([
        import('lottie-web'),
        import('./kithhr_load.json')
    ]).then(([lottieModule, animDataModule]) => {
        try {
            const lottie = (lottieModule as any).default || lottieModule;
            const kithhrLoadAnimation = (animDataModule as any).default || animDataModule;

            lottieAnimInstance = lottie.loadAnimation({
                container: lottieContainer,
                renderer: 'svg',
                loop: true,
                autoplay: true,
                animationData: kithhrLoadAnimation,
                rendererSettings: {
                    preserveAspectRatio: 'xMidYMid meet'
                }
            });

            lottieAnimInstance.setSpeed(1.8);

            const hideFallback = () => {
                const fallbackUi = document.getElementById('loader-fallback-ui');
                if (fallbackUi) {
                    fallbackUi.style.transition = 'opacity 0.3s ease-out';
                    fallbackUi.style.opacity = '0';
                    setTimeout(() => {
                        fallbackUi.style.display = 'none';
                    }, 300);
                }
            };

            lottieAnimInstance.addEventListener('DOMLoaded', hideFallback);
            setTimeout(hideFallback, 400);
        } catch (err) {
            console.warn('Lottie splash init error:', err);
        }
    }).catch(err => {
        console.warn('Native Lottie load error:', err);
    });
}

// Global helper to re-trigger splash video animation on launch or app resume
(window as any).triggerSplashAnimation = (durationMs = 1800) => {
    const loader = document.getElementById('initial-loader');
    if (!loader) return;

    loader.style.setProperty('display', 'flex', 'important');
    loader.style.opacity = '1';
    loader.style.transition = 'none';

    const fallbackUi = document.getElementById('loader-fallback-ui');
    if (fallbackUi) fallbackUi.style.display = 'none';

    if (lottieAnimInstance) {
        lottieAnimInstance.goToAndPlay(0, true);
    }

    setTimeout(() => {
        loader.style.transition = 'opacity 0.5s ease-out';
        loader.style.opacity = '0';
        setTimeout(() => {
            loader.style.setProperty('display', 'none', 'important');
        }, 500);
    }, durationMs);
};

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
    <React.StrictMode>
        <AuthProvider>
            <DataProvider>
                <Router>
                    <App />
                </Router>
            </DataProvider>
        </AuthProvider>
    </React.StrictMode>
);
